import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { api } from 'core/api/ConnectionManager'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    MENU_PRODUCT_CATALOG_CONFIG,
    MENU_PRODUCT_CATALOG_TYPE,
    MenuProductAdditionalData,
    MenuProductCatalogOption,
    MenuProductSelectedItems,
} from './InstancesCatalogMenuProduct-types'

const InstancesCatalogMenuProductComponent = () => {
    const [selectedItems, setSelectedItems] = useState<MenuProductSelectedItems>([])
    const [additionalData, setAdditionalData] = useState<MenuProductAdditionalData>({
        productMenus: [],
    })

    useEffect(() => {
        api.send('getProductMenus', {}).then((res) => {
            const { data } = res as { data: MenuProductCatalogOption[] }
            setAdditionalData({ productMenus: data })
        })
    }, [])

    return (
        <Content title={MENU_PRODUCT_CATALOG_TYPE}>
            <Catalog
                type={MENU_PRODUCT_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                additionalData={additionalData}
                fixedHeader={MENU_PRODUCT_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={MENU_PRODUCT_CATALOG_CONFIG.isExistRightToolbar}
            />
        </Content>
    )
}

export const InstancesCatalogMenuProduct = checkAvailableModule('instancesCatalog/menuProduct')
    ? InstancesCatalogMenuProductComponent
    : null
